export default __webpack_public_path__ + "media/images/table_layouts/square-bf7ebcfc39deaadf4834c1a784e8f4d0.svg";